/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */

import './batch.tpl.html';
import './bulkRestore/details/bulkRestoreDetails.js';
import './bulkRestore/info/bulkRestoreInfo.js';
import './bulkRestore/navigator/bulkRestoreNavigator.js';
import './gdprRequest/info/gdprRequestInfo';
import './gdprRequest/details/gdprRequestDetails';
import './details/details.js';
import './export/details/exportDetails.js';
import './export/downloads/exportDownload.tpl.html';
import './export/info/exportInfo.js';
import './info/info.js';
import './messages/messages.js';
import './metadataRestore/details/metadataRestoreDetails.js';
import './metadataRestore/info/metadataRestoreInfo.js';
import './metadataRestore/navigator/metadataRestoreNavigator.js';
import './navigator/navigator.js';
import './objectRestore/details/ObjectRestoreDetails.js';
import './objectRestore/info/ObjectRestoreInfo.js';

angular
  .module('batch', [
    'ui.router',
    'batch.export.details',
    'batch.export.info',
    'batch.details',
    'batch.info',
    'batch.messages',
    'batch.navigator',
    'batch.objectRestore.details',
    'batch.objectRestore.info',
    'batch.bulkRestore.details',
    'batch.bulkrestore.info',
    'batch.bulkrestore.navigator',
    'batch.gdprrequest.info',
    'batch.gdprrequest.details',
    'batch.metadataRestore.details',
    'batch.metadataRestore.info',
    'batch.metadataRestore.navigator',
    'sbsf.constants',
    'services.activity'
  ])
  .constant('CHECKED_STATUS', {
    ALL: 1,
    SOME: 2,
    NONE: 3
  })
  .constant('BATCH_RESULT_TABS', {
    RECORDS: 1,
    METADATA: 2
  })
  .constant('BULK_RESTORE_BATCH_RESULT_TABS', {
    ERRORS: 1,
    SUCCESS: 2,
    NON_RESTORABLE: 3,
    OVERWRITE: 4,
    SPECIFIC_FIELDS: 5
  })
  .constant('METADATA_RESTORE_BATCH_RESULT_TABS', {
    ERRORS: 1,
    SUCCESS: 2
  })
  // This defines the main abstract main view that is shared across all
  // subviews.
  .config([
    '$stateProvider',
    'VIEW_STATES',
    function ($stateProvider, VIEW_STATES) {
      /**
       * Utility function used to specify a batch value that must be populated prior to loading the state.
       * It will ensure that the batchUtils.currentBatch object is populated with the
       * passed batch id or use the currentBatch.  It is used by assigning it to a property in
       * the resolve object in a state configuration object.
       */
      var batchInfoResolver = [
        '$stateParams',
        '$rootScope',
        'batchUtils',
        '$state',
        function ($stateParams, $rootScope, batchUtils, $state) {
          if ($stateParams.batchId) {
            return batchUtils
              .loadBatch($stateParams.batchId)
              .then(function () {
                return batchUtils.currentBatch;
              })
              .catch(function () {
                $rootScope.accessError = true;
                $state.go(VIEW_STATES.INVALID_CONFIG);
              });
          } else {
            // An empty object will result in a redirect to the admin page due to checks in the
            // controllers.
            return {};
          }
        }
      ];

      $stateProvider
        .state(VIEW_STATES.BATCH, {
          abstract: true,
          resolve: {
            lastState: [
              '$state',
              function ($state) {
                var currentState = $state.current.name,
                  lastState;
                // Ignore the account state to avoid getting stuck in a circular nav loop.
                // We never go directly to a batch from the account page.
                if (currentState !== VIEW_STATES.ACCOUNT) {
                  lastState = currentState;
                }
                return lastState;
              }
            ]
          },
          views: {
            content: {
              templateUrl: 'batch/batch.tpl.html',
              controller: 'BatchCtrl'
            }
          }
        })
        // The views that are rendered in the batch view.
        .state(VIEW_STATES.BATCH_HOME, {
          url: '/batch/{batchId}',
          resolve: {
            // specifies a value that must be populated prior to loading the state.
            // This case will results in ensuring the batchUtils.currentBatch object is
            // populated.
            batchInfo: batchInfoResolver,
            orgInfo: [
              'accountUtils',
              function (accountUtils) {
                return accountUtils.getOrgInfo();
              }
            ],
            restorableTypes: [
              'httpBulkRestore',
              function (httpBulkRestore) {
                return httpBulkRestore.getTypes({});
              }
            ]
          },
          views: {
            details: {
              templateUrl: 'batch/details/details.tpl.html'
            }
          }
        })
        // The export view
        .state(VIEW_STATES.BATCH_EXPORT, {
          url: '/export/{batchId}',
          resolve: {
            batchInfo: batchInfoResolver
          },
          views: {
            info: {
              templateUrl: 'batch/export/info/exportInfo.tpl.html',
              controller: 'ExportInfoCtrl'
            },
            details: {
              templateUrl: 'batch/export/details/exportDetails.tpl.html',
              controller: 'ExportDetailsCtrl'
            },
            downloads: {
              templateUrl: 'batch/export/downloads/exportDownload.tpl.html',
              controller: 'ExportInfoCtrl'
            },
            messages: {
              templateUrl: 'batch/messages/messages.tpl.html',
              controller: 'BatchMessagesCtrl'
            }
          }
        })
        // The Object Restore view
        .state(VIEW_STATES.BATCH_OBJECT_RESTORE, {
          url: '/objectrestore/{batchId}',
          resolve: {
            batchInfo: batchInfoResolver
          },
          views: {
            info: {
              templateUrl: 'batch/objectRestore/info/objectRestoreInfo.tpl.html',
              controller: 'ObjectRestoreInfoCtrl'
            },
            messages: {
              templateUrl: 'batch/messages/messages.tpl.html',
              controller: 'BatchMessagesCtrl'
            }
          }
        })
        // The Bulk Restore view
        .state(VIEW_STATES.BATCH_BULK_RESTORE, {
          url: '/bulkrestore/{batchId}',
          resolve: {
            batchInfo: batchInfoResolver,
            batchErrors: [
              '$stateParams',
              'batchUtils',
              function ($stateParams, batchUtils) {
                if ($stateParams.batchId) {
                  return batchUtils.getEventCountForBatch($stateParams.batchId).then(function (result) {
                    return result;
                  });
                } else {
                  return {};
                }
              }
            ]
          },
          views: {
            info: {
              templateUrl: 'batch/bulkRestore/info/bulkRestoreInfo.tpl.html',
              controller: 'BulkRestoreInfoCtrl'
            },
            details: {
              templateUrl: 'batch/bulkRestore/details/bulkRestoreDetails.tpl.html',
              controller: 'BulkRestoreDetailsCtrl'
            },
            messages: {
              templateUrl: 'batch/messages/messages.tpl.html',
              controller: 'BatchMessagesCtrl'
            },
            navigator: {
              templateUrl: 'batch/bulkRestore/navigator/bulkRestoreNavigator.tpl.html',
              controller: 'BulkRestoreNavigatorCtrl'
            }
          }
        })
        // The Gdpr Request view
        .state(VIEW_STATES.BATCH_GDPR_REQUEST, {
          url: '/gdprrequest/{batchId}',
          resolve: {
            batchInfo: batchInfoResolver
          },
          views: {
            info: {
              templateUrl: 'batch/gdprRequest/info/gdprRequestInfo.tpl.html',
              controller: 'GdprRequestInfoCtrl'
            },
            messages: {
              templateUrl: 'batch/messages/messages.tpl.html',
              controller: 'BatchMessagesCtrl'
            },
            details: {
              templateUrl: 'batch/gdprRequest/details/gdprRequestDetails.tpl.html',
              controller: 'GdprRequestDetailsCtrl'
            }
          }
        })
        // The metadata Restore view
        .state(VIEW_STATES.BATCH_METADATA_RESTORE, {
          url: '/metadatarestore/{batchId}',
          resolve: {
            batchInfo: batchInfoResolver,
            batchErrors: [
              '$stateParams',
              'batchUtils',
              function ($stateParams, batchUtils) {
                if ($stateParams.batchId) {
                  return batchUtils.getEventCountForBatch($stateParams.batchId).then(function (result) {
                    return result;
                  });
                } else {
                  return {};
                }
              }
            ]
          },
          views: {
            info: {
              templateUrl: 'batch/metadataRestore/info/metadataRestoreInfo.tpl.html',
              controller: 'MetadataRestoreInfoCtrl'
            },
            details: {
              templateUrl: 'batch/metadataRestore/details/metadataRestoreDetails.tpl.html',
              controller: 'MetadataRestoreDetailsCtrl'
            },
            messages: {
              templateUrl: 'batch/messages/messages.tpl.html',
              controller: 'BatchMessagesCtrl'
            },
            navigator: {
              templateUrl: 'batch/metadataRestore/navigator/metadataRestoreNavigator.tpl.html',
              controller: 'MetadataRestoreNavigatorCtrl'
            }
          }
        });
    }
  ])
  /**
   * Controller for the abstract batch view. It only contains values that are
   * inherited and utilized by it's implementing views.
   */
  .controller('BatchCtrl', [
    '$scope',
    '$state',
    'batchUtils',
    'activityUtils',
    'CHECKED_STATUS',
    function ($scope, $state, batchUtils, activityUtils, CHECKED_STATUS) {
      // Tie batchUtils to a local scope.
      $scope.batchUtils = batchUtils;
      $scope.bulkRestoreQuery = '';
      $scope.showDetailsMask = false;
      $scope.typeQuery = {
        // If there's an initial type specified (from the Dashboard favorites) use that type as the initial filter
        records: batchUtils.initialObjectType || '',
        metadata: ''
      };

      const batchViewState = activityUtils.getBatchViewState(batchUtils.currentBatch);
      if ($state.current.name !== batchViewState) {
        activityUtils.goToBatch(batchUtils.currentBatch);
      }

      /**
       * Resets the batch view
       */
      function resetBatchView() {
        // allChecked status
        $scope.allCheckedRecords = CHECKED_STATUS.NONE;
        $scope.allCheckedMetadata = CHECKED_STATUS.NONE;
        // Set a scope value for the CHECKED_STATUS constant in so implementing scopes have access.
        $scope.CHECKED_STATUS = CHECKED_STATUS;
        // Track the currently selected count.
        $scope.selectedCount = 0;
        // Track the currently selected metadata count.
        $scope.selectedMetadataCount = 0;
        // Array to hold the currently selected types.
        $scope.selectedTypes = [];
        // Array to hold the currently selected metadata types.
        $scope.selectedMetadataTypes = [];
        // Determines if the messages view should be shown.
        $scope.showMessages = false;
        // Flag to display only fields with difference.
        $scope.showModifiedRecordsOnly = false;
        $scope.showModifiedMetadataOnly = false;
      }

      resetBatchView();

      // Anytime that the currentBatch changes update the batch UI.
      $scope.$watch(
        function () {
          return $scope.batchUtils.currentBatch;
        },
        function () {
          resetBatchView();
        }
      );
    }
  ]);
